import React, { Component } from 'react'
import AmCharts from "@amcharts/amcharts3-react";

/**
 * Stacked columns (y_axis fields, e.g. sent_count/opened_count/paid_count) on the left axis,
 * plus one line series (line_field, e.g. paid_percentage) on its own right-hand axis -
 * same pattern as the existing "EMI Transactions by Scheme" stacked chart in
 * DashboardDetails.jsx, with a %/rate line overlaid on top.
 *
 * Built by combining StackedColumnChart.jsx's stackType:"regular" config with
 * BarAndLineChart.jsx's per-series line-graph styling, rather than as a one-off -
 * so any future "stacked bars + a trend line" chart (not just Link's funnel) can reuse this.
 *
 * Props:
 *   data          - array of row objects, one per x-axis category
 *   x_axis        - category field name (e.g. "day")
 *   y_axis        - array of field names to stack as columns (e.g. ["sent_count","opened_count","paid_count"])
 *   line_field    - field name to render as a line on the secondary axis (e.g. "paid_percentage")
 *   line_title    - legend/axis title for the line (e.g. "Paid %")
 *   name          - export file name
 *   chartHeight   - CSS height string (e.g. "250px")
 */
class StackedColumnWithLineChart extends Component {

    render() {
        const barColors = ["#2196f3", "#ff9900", "#109618", "#dc3912", "#990099", "#0099c6"];

        let fileName = this.props.name;
        if (fileName === null || fileName === 'null' || fileName === undefined || fileName === 'undefined') {
            fileName = "chartData";
        }

        const graphs = [];
        (this.props.y_axis || []).forEach((field, index) => {
            graphs.push({
                "id": "col" + index,
                "valueAxis": "stackAxis",
                "balloonText": "[[title]]: [[value]]",
                "labelText": "[[percents]]%",
                "fillAlphas": 0.85,
                "lineAlpha": 0.2,
                "fontSize": 11,
                "title": field,
                "type": "column",
                "valueField": field,
                "fillColors": barColors[index % barColors.length],
                "fixedColumnWidth": 20
            });
        });

        // Secondary line series (e.g. paid %) - own right-hand axis so its scale (0-100%)
        // doesn't get squashed by the much larger stacked-column counts.
        if (this.props.line_field) {
            graphs.push({
                "id": "line0",
                "valueAxis": "lineAxis",
                "valueField": this.props.line_field,
                "title": this.props.line_title || this.props.line_field,
                "type": "line",
                "lineThickness": 2,
                "bullet": "round",
                "bulletSize": 5,
                "bulletBorderAlpha": 1,
                "bulletColor": "#FFFFFF",
                "useLineColorForBulletBorder": true,
                "lineColor": "#dc3912",
                "balloonText": "[[title]]: [[value]]%"
            });
        }

        const valueAxes = [
            {
                "id": "stackAxis",
                "stackType": "regular",
                "position": "left",
                "axisAlpha": 0.3,
                "gridAlpha": 0
            }
        ];
        if (this.props.line_field) {
            valueAxes.push({
                "id": "lineAxis",
                "position": "right",
                "title": this.props.line_title || this.props.line_field,
                "axisAlpha": 1,
                "gridAlpha": 0,
                "minimum": 0,
                "maximum": 100
            });
        }

        const config = {
            "type": "serial",
            "theme": "none",
            "legend": {
                "autoMargins": false,
                "position": "bottom",
                "borderAlpha": 0,
                "equalWidths": false,
                "horizontalGap": 10,
                "markerSize": 10,
                "useGraphSettings": true,
                "valueAlign": "left",
                "valueWidth": 0,
                "fontSize": 8
            },
            "dataProvider": this.props.data,
            "synchronizeGrid": true,
            "valueAxes": valueAxes,
            "graphs": graphs,
            "marginTop": 30,
            "marginRight": this.props.line_field ? 40 : 0,
            "marginLeft": 90,
            "marginBottom": 40,
            "autoMargins": false,
            "categoryField": this.props.x_axis,
            "categoryAxis": {
                "gridPosition": "start",
                "minorGridEnabled": false,
                "axisAlpha": 1,
                "gridAlpha": 0,
                "labelRotation": 25,
                "fontSize": 8
            },
            "chartCursor": {
                "valueLineEnabled": true,
                "valueLineBalloonEnabled": true,
                "cursorAlpha": 1,
                "cursorColor": "#258cbb",
                "valueLineAlpha": 0.2
            },
            "export": {
                "enabled": true,
                "fileName": fileName.replace(/ /g, "_"),
                "menu": [{
                    "class": "export-main",
                    "menu": ["XLSX", "CSV"]
                }]
            }
        };

        return (
            <div className="chart_div">
                <AmCharts.React style={{ width: "100%", height: this.props.chartHeight || "250px" }} options={config} />
            </div>
        );
    }
}

export default StackedColumnWithLineChart;
